export default __webpack_public_path__ + "static/2-1-accessibility-57f7169bfbd09c31332b14091c2ca6f2.gif";